/**
 * 全站设计令牌 - 对标国内航线燃油附加费计算器 UI
 * 字体对标国内航线燃油附加费计算器（DingTalk JinBuTi）
 */
export const theme = {
  token: {
    colorPrimary: '#165dff',
    colorLink: '#165dff',
    colorText: '#1d2129',
    colorTextSecondary: '#4e5969',
    colorTextTertiary: '#86909c',
    colorBorder: '#e5e6eb',
    colorBorderSecondary: '#e8f2ff',
    colorBgLayout: '#f5f7fa',
    colorBgContainer: '#FFFFFF',
    colorFillAlter: '#f7faff',
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 10,
    fontFamily: '"DingTalk JinBuTi", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    fontSizeLG: 15,
    fontSizeSM: 13,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    lineHeight: 1.65,
    controlHeight: 42,
    controlHeightLG: 46,
    paddingContentHorizontal: 16,
    motionDurationMid: '0.2s',
  },
  components: {
    Button: {
      borderRadius: 10,
      controlHeight: 42,
      controlHeightLG: 46,
      primaryShadow: '0 6px 14px rgba(22, 93, 255, 0.2)',
      defaultBorderColor: '#e5e6eb',
    },
    Card: {
      borderRadiusLG: 14,
      paddingLG: 16,
    },
    Input: {
      borderRadius: 10,
      controlHeight: 42,
      controlHeightLG: 46,
      activeBorderColor: '#165dff',
      hoverBorderColor: '#c9cdd4',
    },
    Select: {
      borderRadius: 10,
      controlHeight: 42,
      controlHeightLG: 46,
    },
    Form: {
      labelFontSize: 13,
      labelColor: '#4e5969',
      itemMarginBottom: 16,
    },
    Menu: {
      horizontalItemSelectedColor: '#165dff',
      itemSelectedColor: '#165dff',
      itemHeight: 46,
    },
    Table: {
      headerBg: '#f7faff',
      headerColor: '#4e5969',
      headerSplitColor: '#e5e6eb',
      rowHoverBg: '#f8fbff',
      borderColor: '#e5e6eb',
      cellPaddingBlock: 6,
      cellPaddingInline: 8,
    },
    Segmented: {
      borderRadius: 10,
      itemSelectedBg: '#165dff',
      itemSelectedColor: '#FFFFFF',
      trackBg: '#f2f3f5',
      trackPadding: 4,
    },
    Tabs: {
      inkBarColor: '#165dff',
      itemSelectedColor: '#165dff',
      itemHoverColor: '#4080ff',
    },
    Alert: {
      borderRadiusLG: 12,
    },
    Modal: {
      fontFamily: '"DingTalk JinBuTi", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',
    },
    Message: {
      fontFamily: '"DingTalk JinBuTi", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',
    },
    Notification: {
      fontFamily: '"DingTalk JinBuTi", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',
    },
  },
};
